import React from 'react';

//Scripts auxiliares:
let urlFormatter = require('../../../tools/formatters/urlFormatter');

//Estilos base:
let paragraphBaseStyle = {
    textTransform: "none", marginBottom: 0,
    paddingTop: 5
};

function HyperlinkLabel(props) {
    return (
        <p className="category" style={{ ...paragraphBaseStyle, ...props.style, cursor: "pointer" }}
            title={props.urlTarget} onClick={() => {
                window.open(props.urlTarget, "_blank")
            }}>
            {urlFormatter.formatShortURL(props.urlTarget, 18)}
        </p>
    );
}

export default HyperlinkLabel;